import React from "react";
import {
  Grid,
  TableBody,
  TableRow,
  CardContent,
  Divider,
  Card,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import { readableFormatDate } from "shared/utils";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";

export const EaseBuzzDetails = ({ data }) => {
  if (!data) return null;

  return (
    <Card>
      <CardContent className="card-content_head">
        <Grid container alignItems="center">
          <Grid item xs={12}>
            Easebuzz Payment Details
          </Grid>
        </Grid>
      </CardContent>

      <Divider />

      <CardContent>
        <CustomTableWrapper>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <table className="w-full">
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Payment Reference No
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data.payment_reference_number}
                  </TableBodyCell>
                </TableRow>

                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Easebuzz Identifier
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data.easebuzz_identifier}
                  </TableBodyCell>
                </TableRow>

                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Bank Reference ID
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data.bank_reference_identifier}
                  </TableBodyCell>
                </TableRow>

                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Payment Mode
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data.payment_mode}
                  </TableBodyCell>
                </TableRow>
              </TableBody>
            </table>
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12}>
            <table className="w-full">
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Status
                  </TableBodyCell>
                  <TableBodyCell>
                    <BootstrapBadge text={data.status} />
                  </TableBodyCell>
                </TableRow>

                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Error Message
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data.error_message}
                  </TableBodyCell>
                </TableRow>

                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Credentials Of
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data.credentials_of}
                  </TableBodyCell>
                </TableRow>

                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Created At
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data.created_at)}
                  </TableBodyCell>
                </TableRow>

                <TableRow>
                  <TableBodyCell className="common_table_title">
                    Updated At
                  </TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data.updated_at)}
                  </TableBodyCell>
                </TableRow>
              </TableBody>
            </table>
          </Grid>
        </CustomTableWrapper>
      </CardContent>
    </Card>
  );
};
